import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, AfterViewInit ,OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
//import { Http } from '@angular/http';

//import * as schoolsetup  from '../school.forms';
import { ProjectmanagementService } from '../../../../../projectmanagement/src/app/service/projectmanagement.service';
import { SchoolService } from '../../service/school.service';
import { MyErrorHandler } from '../../../../../projectmanagement/src/app/errorhandler/errorhandler';
import { Class, Grade, Subject, Year } from '../../model/school.model';
import { OrderByPipe } from 'ngx-pipes';

declare var jQuery;

@Component({
  selector: 'app-ctl-gradeclass-form',
  templateUrl: './ctl.school.gradeclass.component.html',
  styleUrls: ['./ctl.school.gradeclass.component.css'],
  providers: [SchoolService, ProjectmanagementService]
})


export class AddGradeClassComponent implements OnInit {

  loaded = false;
  nextClicked = false;
  gradeClassForm: FormGroup;

  @Input() project_id: string;

  school_id: string;
  year: string;
  grade_id: string;

  gradeList: Grade[];
  gradeDataList = [];
  schoolDetails:any =[];
  classList: Class[];
  ClassDataList = [];
  classesList = [];
  step = 1;
textDir:any;
  constructor(
    private _fb: FormBuilder,
    private schoolService: SchoolService,
    private projectService: ProjectmanagementService,
    private router: Router,
    private route: ActivatedRoute) {
      this.textDir =  sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    this.gradeClassForm = this._fb.group({
      gradeArray: this._fb.array([])
    });
    this.nextClicked = false;
    
  }

  addGradesToForm() {
    const orderByPipe = new OrderByPipe();

    this.gradeClassForm = this._fb.group({
      gradeArray: this._fb.array([])
    });

    const control = this.gradeClassForm.controls['gradeArray'] as FormArray;
    const classDataList = this.classList;
    this.classesList = this.classList;
    let i = 0;

    this.gradeList = orderByPipe.transform(this.gradeList, 'year.number');
    this.gradeList.forEach(element => {
      let classes = '';
      if (classDataList && classDataList.length) {
        this.gradeList[i].classes = [];
        classDataList.forEach(item => {
          if (element.name === item.grade.name) {
            this.gradeList[i].classes.push(item);
            if (classes) {
              classes = classes + ',' + item.name;
            } else {
              classes = item.name;
            }
            // find and remove class already added
          }
        });
        control.push(this.patchGrade(element, classes));
      } else {
        control.push(this.patchGrade(element, ''));
      }
      i++;
    });
    this.loaded = true;

  //  console.log('grade Class form ======' + JSON.stringify(this.gradeClassForm.value));

  }

  patchGrade(grade, classes?) {
    return this._fb.group({
      grade: [grade],
      classes: [classes]
    });
  }
getSchoolDetails(){
  this.schoolService.detail(this.school_id).subscribe(
    (response) => {    
     
      this.schoolDetails = response;
      console.log('school details jani :' + JSON.stringify(this.schoolDetails));
      return true;
    },
    (err) => {
      const errorHandlerObj = new MyErrorHandler();
      const errorHandler = errorHandlerObj.handleError(err);
      if (errorHandler.isSssionExpired) {
        this.router.navigate(['/login']);
        return true;
      }
    },
    () => {
    //console.log('COMPLETED');
    }
  );
}
  getGradeClassList() {
    
    this.schoolService.getClassList(this.school_id).subscribe(
      (response) => {
        console.log('schoold :' + JSON.stringify(this.school_id));
         console.log('Class List jani :' + JSON.stringify(response));
        this.classList = response;
        this.getGradeList();
        this.getSchoolDetails();
        return true;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      //console.log('COMPLETED');
      }
    );
  }
  
  getGradeList() {
    this.projectService.listProjectGrade(this.project_id).subscribe(
      (response) => {
        console.log('Grade List jani :' + JSON.stringify(response));
        this.gradeList = response;
        this.addGradesToForm();
        this.loaded = true;
        return true;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      //console.log('COMPLETED');
      }
    );
  }

  submitGradeClass() {
    return new Promise((resolve, reject) => {
      this.addGradeClass().then( res=> {
        resolve();
      });
    });
  }
  
  addGradeClass() {
    //

    return new Promise((resolve, reject) => {
    const data = [];

    const tmp = this.gradeClassForm.value.gradeArray;
    // alert("tmp >>> "+JSON.stringify(tmp));
    // alert(JSON.stringify(this.classList));
    tmp.forEach(row => {
      //
      if (row && row.grade) {
        if (row && row.classes) {
          const classes = row.classes.split(',');
          classes.forEach(val => {
            // if (
            //   this.classList.map( e =>  e.name ).indexOf(val.trim()) === -1 &&
            //   this.classList.map( e => e.grade.name ).indexOf(row.grade.name) === -1
            // ) {
              data.push({name: val.trim(), grade_id: row.grade._id});
            // }
          });
        }
      }

    });
    console.log('KAJAL');
    console.log(data);
    if (data && data.length > 0) {
      //
      const olddata = JSON.stringify(this.classList);
      const newdata = JSON.stringify(data);

      if ( olddata === newdata) {
        return true;
      }
      
      //console.log('grade Class form ======' + JSON.stringify(this.gradeClassForm.value));
     //console.log('grade Class data ======' + JSON.stringify(data));
      this.schoolService.addGradeClass(data, this.school_id).subscribe(
        (response) => {
          //console.log('Grade Class Added :' + JSON.stringify(response));
          this.getGradeClassList();
          return true;
        },
        (err) => {
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
          reject();
        },
        () => {
       // console.log('COMPLETED');
          resolve();
        }
      );
    }
    //console.log('nothing to add');
    // error/warning msg on screen
    });
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('bodyBG');
  }

}
